import { AlertSection } from './alert-section';
import { DetailsSection } from './details-section';
import { WrappingSection } from './wrapping-section';

export const GeneralBlock = () => {
  return (
    <section className='flex flex-col pt-8 space-y-8'>
      <WrappingSection />
      <AlertSection />
      <DetailsSection />
    </section>
  );
};
